import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { Parameter } from "../models/Parameter";
import { AssistanceInfoFromReminderResponseDTO } from "../models/Reminder/AssistanceInfoFromReminderResponseDTO";
import { CancelReminderDTO } from "../models/Reminder/CancelReminderDTO";
import { ConvertReminderToScheduleDTO } from "../models/Reminder/ConvertReminderToScheculeDTO";
import { CreateReminderDTO } from "../models/Reminder/CreateReminderDTO";
import { EditReminderDTO } from "../models/Reminder/EditReminderDTO";
import { ReminderDTO } from "../models/Reminder/ReminderDTO";
import { ReminderSearchResultDTO } from "../models/Reminder/ReminderSearchResultDTO";
import { ReminderStatusListDTO } from "../models/Reminder/ReminderStatusListDTO";
import { RemindersFromMaintenancePlanRequestDTO } from "../models/Reminders/RemindersFromMaintenancePlanRequestDTO";
import { RemindersFromMaintenancePlanResponseDTO } from "../models/Reminders/RemindersFromMaintenancePlanResponseDTO";
import { APIService } from "./APIService";

export class ReminderService {
    async GetAll(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<ReminderSearchResultDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Reminder/GetAll`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<ReminderSearchResultDTO>(
                false,
                "Erro ao ligar ao servidor ao obter a informação das manutenções",
                "",
                [],
                0,
            );
        }
    }

    async GetById(reminderId: number | undefined): Promise<MessagingHelper<ReminderDTO | null>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/Reminder/GetById?reminderId=${reminderId}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor ao obter a informação da manutenção",
                null
            );
        }
    }

    async Create(
        reminder: CreateReminderDTO
    ): Promise<MessagingHelper<number | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Reminder/Create`,
                { ...reminder },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<number | null>(
                false,
                "Erro ao ligar ao servidor para criar a manutenção",
                null
            );
        }
    }

    async Edit(
        reminder: EditReminderDTO): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().put(
                `${APIService.GetURL()}/Reminder/Edit`,
                { ...reminder },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para editar a manutenção",
                null
            );
        }
    }

    async ConvertToSchedule(
        reminder: ConvertReminderToScheduleDTO
    ): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Reminder/ConvertToSchedule`,
                { ...reminder },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para converter a manutenção em um agendamento",
                null
            );
        }
    }

    async GetRemindersFromMaintenancePlan(
        search: RemindersFromMaintenancePlanRequestDTO
    ): Promise<PaginatedList<RemindersFromMaintenancePlanResponseDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Reminder/GetRemindersFromMaintenancePlan`,
                {
                    ...search,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<RemindersFromMaintenancePlanResponseDTO>(
                false,
                "Erro ao ligar ao servidor para obter as manutenções do plano de manutenção",
                "",
                [],
                0
            );
        }
    }

    async CreateAutomaticReminders(maintenancePlanId: Number): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Reminder/CreateAutomaticReminders?maintenancePlanId=${maintenancePlanId}`,
                {},
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para criar as manutenções",
                null
            );
        }
    }

    async Cancel(
        reminder: CancelReminderDTO): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().put(
                `${APIService.GetURL()}/Reminder/Cancel`,
                { ...reminder },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para cancelar a manutenção",
                null
            );
        }
    }

    async ConvertMaintenanceToAssistance(reminderId: Number | null): Promise<MessagingHelper<string | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Reminder/ConvertMaintenanceToAssistance?reminderId=${reminderId}`,
                {},
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<string | null>(
                false,
                "Erro ao ligar ao servidor para converter a manutenção em assistência",
                null
            );
        }
    }

    async AssistanceInfoFromReminder(reminderId: Number | null): Promise<MessagingHelper<AssistanceInfoFromReminderResponseDTO | null>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/Reminder/AssistanceInfoFromReminder?reminderId=${reminderId}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<AssistanceInfoFromReminderResponseDTO | null>(
                false,
                "Erro ao ligar ao servidor para obter dados da assistência associada à manutenção",
                null
            );
        }
    }

    async GetStatus(): Promise<MessagingHelper<ReminderStatusListDTO[]>> {
        try {
          var response = await APIService.Axios().get(
            `${APIService.GetURL()}/Reminder/getStatus`,
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + APIService.GetToken(),
              },
            }
          );
          return response.data;
        } catch (error) {
          return new MessagingHelper<ReminderStatusListDTO[]>(
            false,
            "Erro ao ligar ao servidor para obter os estados das manutenções",
            []
          );
        }
      }
}